import api from "./index";
import {UserStatus, UserStatusInfo} from "./accountManagerApi";
import {TableMetaType} from "../components/ExtendedTable";

const SALES_MANAGER = 'sale-manager'

const salesManagerApi = api.injectEndpoints({
    endpoints: build => ({
        getSalesManagers: build.query<GetSalesManagersType, SalesManagerFilter>({
            query: (body) => {
                const {page, name, lastname, email, status} = body;
                const params = new URLSearchParams({
                    page: page.toString(),
                    name,
                    lastname,
                    email,
                    status: status ?? ''
                })

                return `${SALES_MANAGER}?${params}`
            },
        }),

        createSalesManager: build.mutation<null, SalesManagerInfoType>({
            query: body => ({
                url: SALES_MANAGER,
                method: "POST",
                body,
            }),
        }),

        updateSalesManager: build.mutation<null, SalesManagerInfoType>({
            query: body => {
                const {id, ...newBody} = body;
                return {
                    url: `${SALES_MANAGER}/${id}`,
                    method: "PUT",
                    body: newBody,
                }
            },
        }),

        changeSalesManagerStatus: build.mutation<null, UserStatusInfo>({
            query: body => {
                const {status, id} = body

                return {
                    url: `${SALES_MANAGER}/${id}/change-status`,
                    method: 'PUT',
                    body: {status},
                }
            },
        }),
    }),
    overrideExisting: false,
});

export type SalesManagerType = {
    id: number
    name: string
    lastname: string
    email: string
    status: UserStatus
}

export type GetSalesManagersType = {
    items: SalesManagerType[]
    _meta: TableMetaType
}

export type SalesManagerFilter = {
    page: number
    email: string
    name: string
    lastname: string
    status: UserStatus | null
}

export type SalesManagerInfoType = Omit<SalesManagerType, 'status'>

export const {
    useGetSalesManagersQuery,
    useCreateSalesManagerMutation,
    useUpdateSalesManagerMutation,
    useChangeSalesManagerStatusMutation,
} = salesManagerApi;

export default salesManagerApi;
